import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAli = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_5142_2375)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M11.6531 0.0769043H2.33248C1.11863 0.0769043 0.135742 1.06855 0.135742 2.29255V11.692C0.135742 12.9153 1.11863 13.9074 2.33248 13.9074H11.653C12.8665 13.9074 13.849 12.9153 13.849 11.692V2.29255C13.8491 1.06855 12.8667 0.0769043 11.6531 0.0769043Z",
			fill: "#1677FF"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M3.84111 10.7126C1.70768 10.7126 1.07686 9.01772 2.1312 8.09047C2.48311 7.77713 3.12592 7.62407 3.46876 7.58981C4.73609 7.46349 5.90922 7.95109 7.29365 8.63262C6.32045 9.91286 5.08109 10.7126 3.84111 10.7126ZM11.4264 8.76109C10.8776 8.57576 10.1413 8.29224 9.3212 7.99304C9.81372 7.12956 10.2071 6.14621 10.4657 5.07742H7.76266V4.09546H11.0738V3.54731H7.76251V1.9104H6.41112C6.174 1.9104 6.174 2.14644 6.174 2.14644V3.54731H2.82488V4.09546H6.174V5.07742H3.40898V5.62542H8.77182C8.57559 6.30726 8.31204 6.94746 7.99932 7.52911C6.25914 6.95007 4.40232 6.48076 3.2358 6.76966C2.48972 6.95499 2.00934 7.28584 1.72704 7.63253C0.431437 9.22226 1.36054 11.6369 4.09666 11.6369C5.71437 11.6369 7.27276 10.7273 8.48062 9.22825C10.2821 10.1016 13.849 11.6013 13.849 11.6013V9.46399C13.849 9.46399 13.401 9.42803 11.4264 8.76109Z",
			fill: "white"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_5142_2375",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 14,
			height: 14,
			fill: "white"
		})
	}) })]
});
export default SvgAli;
